import { useQuery } from 'react-query';

import api from '@root/api';

export default function useEngines() {
  return useQuery(['engines', { }], () => api.engine.getEngines(), {
    staleTime: 1000 * 60 * 60,
  });
}
